// Dark (default, layout A) or light, remembered per browser.
export type Theme = "dark" | "light";

export function theme(): Theme {
  return document.documentElement.classList.contains("dark") ? "dark" : "light";
}

export function setTheme(t: Theme) {
  document.documentElement.classList.toggle("dark", t === "dark");
  try {
    localStorage.setItem("tb.theme", t);
  } catch {
    /* private window: not remembered */
  }
}
